/*
 * @Author: Chen Zhen
 * @LastEditors: Nie Wie
 * @Description: 添加节点
 * @Date: 2019-03-24 11:41:05
 * @LastEditTime: 2020-04-09 11:05:51
 */

/* eslint-disable no-underscore-dangle */

import zrender from 'zrender'
import _ from 'lodash'
import { CIRCLE_ACTIVE_COLOR } from './timeline.conf'

// 节点
export default class Item {
  constructor({
    data,
    size = 4,
    index,
    position = [ 20, 20 ],
    style, // 外部传入的属性，框架级别必设
    handleChoose,
    placeholderSize = 0,
  }) {
    this.size = size
    this.itemData = data
    this.position = position
    this.handleChoose = handleChoose
    this.index = index

    this.placeholderSize = placeholderSize

    this.zrender = null
    this.circle = null

    this.style = style

    this._isChoose = false
    this._init()

    return this
  }

  get isChoose() {
    return this._isChoose
  }

  set isChoose(isChoose) {
    this._isChoose = isChoose
    this.zrender.remove(this.circle)

    this.circle = this._getPointItem()
    this.zrender.add(this.circle)
  }

  _init = () => {
    this.zrender = new zrender.Group()
    this.circle = this._getPointItem()

    if (this.placeholderSize > 0) {
      this.placeholder = this._getPlaceholder()
      this.zrender.add(this.placeholder) // 用于放大点击面积
    }

    this.zrender.add(this.circle)
    this.zrender.add(this._getPointItem())

    const {
      textFill, textAlign, fontFamily, fontSize,
    } = this.style

    // 添加一个label
    const text = new zrender.Text({
      style: {
        text: this.itemData.typeName || this.itemData.label || this.itemData.title,
        textFill,
        textAlign,
        fontFamily,
        fontSize,
        textPadding: [ 28, 40, 15, 2 ],
      },
      position: this.setTextPosition(),
    })
    text.rotation = 45

    this.zrender.add(text)

    if (_.isFunction(this.handleChoose)) {
      this.zrender.on('click', () => {
        // alert('click')
        // this.$message.info('info')
        this.handleChoose(this, this.itemData, this.index)
      })

      // this.zrender.on('mousedown', () => {
      //   alert('mousedown')
      //   // this.$message.info('mousedown')
      //   this.handleChoose(this, this.itemData, this.index)
      // })
    } else {
      throw new RangeError('handleClick must a function')
    }
  }

  _getPointItem = () => {
    if (this.isChoose) {
      // 选中的节点
      return new zrender.Circle({
        style: {
          fill: CIRCLE_ACTIVE_COLOR,
          stroke: 'rgba(0,0,0,0)',
          // lineWidth: 30,
          shadowBlur: 10,
          shadowColor: '#407BF6',
        },
        // silent: true,
        shape: {
          cx: this.position[0],
          cy: this.position[1],
          r: this.size,
        },
      })
    }
    // 未选中的节点
    return new zrender.Circle({
      style: {
        fill: '#fff',
        stroke: CIRCLE_ACTIVE_COLOR,
        lineWidth: 2,
        shadowBlur: 20,
        shadowColor: 'rgba(255,255,255,0)',
      },
      // silent: true,
      shape: {
        cx: this.position[0],
        cy: this.position[1],
        r: this.size * 0.6,
      },
    })
    // return new zrender.Polyline({
    //   style: {
    //     fill: '#F00',
    //     stroke: DEFAULT_COLOR,
    //     lineWidth: 1,
    //   },
    //   // silent: true,
    //   shape: {
    //     points: [
    //       [ this.position[0], this.position[1] ],
    //       [ this.position[0], this.position[1] - 8 ],
    //     ],
    //   },
    // })
  }

  _getPlaceholder() {
    const halfSize = this.placeholderSize / 2
    return new zrender.Polyline({
      style: {
        fill: 'rgba(0,0,0,0)',
        lineWidth: 0,
      },
      // silent: true,
      shape: {
        points: [
          [ this.position[0] - halfSize, this.position[1] + halfSize ],
          [ this.position[0] + halfSize, this.position[1] + halfSize ],
          [ this.position[0] + halfSize, this.position[1] - halfSize ],
          [ this.position[0] - halfSize, this.position[1] - halfSize ],
        ],
      },
    })
  }

  // 字体的位置
  setTextPosition = () => {
    let resetPosition = []
    if (this.style.textAlign === 'center') {
      resetPosition = [ this.position[0] - 10, this.position[1] - 30 ]
    } else if (this.style.textAlign === 'left') {
      resetPosition = [ this.position[0] + 15, this.position[1] - 5 ]
    } else if (this.style.textAlign === 'right') {
      resetPosition = [ this.position[0] - 10, this.position[1] - 30 ]
    }
    return resetPosition
  }
}
